import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { addFavorite, removeFavorite } from 'src/app/product/store/actions';
import { selectFavorites } from 'src/app/product/store/selectors';

@Component({
  selector: 'app-favorites-star',
  templateUrl: './favorites-star.component.html',
  styleUrls: ['./favorites-star.component.scss'],
  imports: [MatIconModule, MatTooltipModule, MatProgressSpinnerModule, CommonModule, AgrI18nSharedModule],
})
export class FavoritesStarComponent implements OnInit, OnDestroy {
  @Input() skuId: number;
  @Input() isFavoritePage = false;
  isFavorite = false;
  buttonDisabled = true;
  private destroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectFavorites)
      .pipe(takeUntil(this.destroy$))
      .subscribe((favoriteSkus) => {
        this.buttonDisabled = false;
        this.isFavorite = favoriteSkus?.map((x) => x.id).includes(this.skuId);
        this.changeDetectorRef.detectChanges();
      });
  }

  toggleFavorite() {
    if (this.buttonDisabled) {
      return;
    }

    this.buttonDisabled = true;
    if (this.isFavorite) {
      this.store.dispatch(removeFavorite({ skuId: this.skuId }));
    } else {
      this.store.dispatch(addFavorite({ skuId: this.skuId }));
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
